import VideoTutorialRow from './VideoTutorialRow';

export default VideoTutorialRow;
